// extracted by mini-css-extract-plugin
export var activeDot = "_26-c";
export var buttonContainer = "_26-9";
export var channelButton = "_26-a";
export var clickable = "_26-d";
export var content = "_26-0";
export var contentFull = "_26-2";
export var contentThird = "_26-1";
export var contentWrapper = "_26-7";
export var description = "_26-5";
export var heightShort = "_26-f";
export var image = "_26-3";
export var imageContainer = "_26-4";
export var selectButton = "_26-e";
export var spinnerContainer = "_26-b";
export var titleContent = "_26-8";
export var titleWrapper = "_26-6";